const formItems = [
  { label: '模板名称', model: 'tplName', type: 'input', span: 6 },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' },
      { message: '草稿箱', type: 'success', fun: 'draft' }
    ],
    span: 18
  }
];
export { formItems };
